// CDFI Lenders Page Content Configuration

export const CDFI_LENDERS_CONTENT = {
  headline: "Islamic Financing — Proven, Standardized, and Ready to Deploy",
  description: "HalalCred is built in partnership with Craft3, a CDFI that has already demonstrated that Islamic financing can be:",
  benefits: [
    "Scalable",
    "Compliant",
    "Operationally manageable",
    "Fully aligned with CDFI missions"
  ],
  whyItMattersTitle: "Why This Matters for CDFIs",
  whyItMattersDescription: "Craft3 has shown that Islamic financing:",
  whyItMattersPoints: [
    "Performs comparably to conventional lending",
    "Can be serviced within standard loan systems",
    "Attracts strong, values-aligned borrowers",
    "Builds deep trust in underserved communities"
  ],
  halalcredPackagesTitle: "HalalCred now packages that experience into:",
  halalcredPackages: [
    "Reusable product frameworks",
    "Standard documentation",
    "Centralized Shariah governance",
    "Shared learning and deal flow"
  ],
  ctaButtonText: "Become a CDFI Partner"
};

